<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <v-form ref="form">
      <HeaderCriticism />
      <v-row>
        <v-col cols="12" class="mb-5">
          <v-radio-group v-model="form.tipo" row>
            <v-radio
              v-for="(item, key) in listTypeCriticism"
              :key="key"
              :label="item.nome"
              :value="item"
            />
          </v-radio-group>
        </v-col>
        <v-col cols="12">
          <BaseFormTextArea
            id-element="reasonCancelEndorsement"
            placeholder="Inserir"
            v-model="form.comentario"
            :rules="[requiredInput, maxLengthTextArea]"
            label-text="Comentário"
          />
        </v-col>
        <v-col cols="12">
          <p class="primary--text mb-2 body-2 font-weight-bold">
            Anexar documentos (se necessários)
          </p>
        </v-col>
        <v-col cols="12">
          <DropFile @selected-files="addFiles" :multiple="true" class="mb-5" />
          <DocumentDataTable
            v-if="form.documentos.length > 0"
            :documents="form.documentos"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFile"
          />
        </v-col>
      </v-row>
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col cols="6" sm="4" md="3" xl="2" class="pr-5">
            <BaseButton
              v-html="'CANCELAR'"
              color="secondary"
              width="100%"
              outlined
              @click="previousPage"
            />
          </v-col>
          <v-col cols="12" sm="5" md="3" xl="2">
            <BaseButton
              v-html="'ENVIAR'"
              class="white--text secondary"
              width="100%"
              @click="submit"
            />
          </v-col>
        </v-row>
      </BaseFooter>
    </v-form>
    <ModalGenericCriticism
      v-model="modal"
      @close="redirectToMessage"
      title="CRÍTICA / MENSAGEM ENVIADA"
      text="Crítica / Mensagem enviada com sucesso. 
            Por favor, aguarde retorno."
    />
  </Main>
</template>
<script>
import ModalGenericCriticism from "../../quotation/components/ModalGenericCriticism";
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import { requiredInput, maxLengthTextArea } from "@/utils/rules.js";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { mapState, mapActions } from "vuex";
import { FILE, documentAlreadyUploaded } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import _ from "lodash";
import HeaderCriticism from "@/components/HeaderCriticism";
import { listTypeCriticism } from "@/utils/utils.js";
export default {
  data: () => ({
    form: {
      documentos: [],
      tipo: null,
      impede_emissao: false,
      comentario: null
    },
    errorMessages: [],
    listTypeCriticism,
    breadcrumb: [
      {
        text: "Críticas",
        to: "quotation element"
      }
    ],
    requiredInput,
    modal: false,
    maxLengthTextArea
  }),
  components: {
    DocumentDataTable,
    DropFile,
    ModalGenericCriticism,
    HeaderCriticism
  },
  computed: {
    ...mapState("policy", ["currentPolicy"]),
    quotationId() {
      return this.currentPolicy.cotacao?.id;
    },
    policyId() {
      return this.$route.params.id;
    }
  },
  mixins: [LoadingRequest, DocumentsMixin],
  created() {
    this.fetchPolicy();
    this.form.tipo = this.listTypeCriticism[0];
  },
  methods: {
    ...mapActions("quotation", [
      "requestNewCriticism",
      "requestCurrentQuotation"
    ]),
    ...mapActions("policy", ["requestCurrentPolicy"]),
    fetchQuotation() {
      this.withLoading(this.requestCurrentQuotation(this.quotationId));
    },
    fetchPolicy() {
      this.withLoading(this.requestCurrentPolicy(this.policyId));
    },
    previousPage() {
      this.$router.push({
        name: "criticism policy",
        params: { id: this.policyId }
      });
    },
    addFiles(files) {
      this.form.documentos = this.form.documentos.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveFile(item) {
      this.form.documentos = this.form.documentos.filter(
        document => document.arquivo.nome !== item.arquivo.nome
      );
    },
    validate() {
      if (!this.form.comentario) {
        this.errorMessages = [
          "É preciso fazer um comentário sobre a crítica/mensagem"
        ];
      } else {
        this.errorMessages = [];
      }
      return this.$refs.form.validate() && this.form.comentario;
    },
    async submit() {
      if (!this.validate()) return;
      this.form.documentos = await this.submitFiles();
      this.withLoading(
        this.requestNewCriticism(this.getPayloadCriticism()).then(() => {
          this.modal = true;
        })
      );
    },
    submitFiles() {
      const { uploadDocument } = this;
      return Promise.all(
        _.map(this.form.documentos, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE], (file, arquivo) => ({
                arquivo
              }))
        )
      );
    },
    getPayloadCriticism() {
      return {
        id: this.quotationId,
        payload: this.form
      };
    },
    redirectToMessage() {
      this.modal = false;
      this.previousPage();
    }
  }
};
</script>
